import type { GridWidgetType } from "../../types";
import type { WidgetCore } from "../../widgetDefinition";

import { chartCore } from "./chart";
import { tableCore } from "./table";
import { table2dCore } from "./table2d";
import { titleCore } from "./title";
import { textCore } from "./text";
import { pieCore } from "./pie";
import { logoCore } from "./logo";
import { statCore } from "./stat";
import { spacerCore } from "./spacer";
import { bodyMapCore } from "./bodyMap";
import { gaugeCore } from "./gauge";
import { radarCore } from "./radar";
import { playerCardCore } from "./playerCard";
import { playerNotesCore } from "./playerNotes";
import { dynamicControllerCore } from "./dynamicController";
import { aiInsightsCore } from "./aiInsights";
import { scatterplotCore } from "./scatterplot";

/**
 * The component-free registry: `process` + `pdf` per widget type, and nothing that
 * imports React components, antd, CSS or Highcharts. `widgetRegistry.ts` still owns the
 * full definitions for the grid; each definition spreads its core, so the two can never
 * disagree. Typed as a `Record` so adding a widget type without a core is a compile error.
 */
const CORES_BY_TYPE: Record<GridWidgetType, WidgetCore> = {
  chart: chartCore as WidgetCore,
  table: tableCore as WidgetCore,
  table_2d: table2dCore as WidgetCore,
  title: titleCore as WidgetCore,
  text: textCore as WidgetCore,
  pie_chart: pieCore as WidgetCore,
  logo: logoCore as WidgetCore,
  spacer: spacerCore as WidgetCore,
  body_map: bodyMapCore as WidgetCore,
  gauge: gaugeCore as WidgetCore,
  radar: radarCore as WidgetCore,
  player_card: playerCardCore as WidgetCore,
  stat_tile: statCore as WidgetCore,
  player_notes: playerNotesCore as WidgetCore,
  slicer: dynamicControllerCore as WidgetCore,
  ai_insights: aiInsightsCore as WidgetCore,
  scatterplot: scatterplotCore as WidgetCore,
};

export function getWidgetCore(type: GridWidgetType): WidgetCore | undefined {
  return CORES_BY_TYPE[type];
}
